const getBaseApiUrl = () => {
  const currentLocation = window.location.hostname

  switch (currentLocation) {
    case 'localhost': {
      return 'https://planner365.bss.dev.pub.gcp/api'
    }
    default: {
      return `https://${window.location.hostname}/api`
    }
  }
}

export type DiagnosticLogLevel = 'info' | 'warn'

export interface DiagnosticLogEvent {
  eventType: string
  outcome?: string
  userId?: string
  path?: string
  timestamp?: string
  level?: DiagnosticLogLevel
}

interface DiagnosticLogRequestBody {
  EventType: string
  Level: DiagnosticLogLevel
  Path?: string
  Outcome?: string
  UserId?: string
  Timestamp: string
}

/**
 * Fire-and-forget diagnostic logging to the unauthenticated /api/log endpoint.
 * Must never throw or block the auth flow — auth decisions cannot depend on
 * whether this call succeeds.
 */
export function logDiagnosticEvent(event: DiagnosticLogEvent): void {
  try {
    const body: DiagnosticLogRequestBody = {
      EventType: event.eventType,
      Level: event.level ?? 'info',
      Path: event.path ?? window.location.pathname,
      Outcome: event.outcome,
      UserId: event.userId,
      Timestamp: event.timestamp ?? new Date().toISOString(),
    }

    fetch(`${getBaseApiUrl()}/log`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch(() => undefined)
  } catch {
    // Never let a logging failure affect the caller.
  }
}

export default logDiagnosticEvent
